import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Log } from "../bo/log";
import { HttpService } from "./http.service";
import { UtilisateurService } from "./utilisateur.service";
import { KeycloakUtilisateurService } from "./keycloak/keycloak-utilisateur.service";

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  dernierMessageErreur = '';
  constructor(private readonly http: HttpService, private readonly utilService: UtilisateurService, private readonly keycloakUtilisateurService: KeycloakUtilisateurService) { }

  logError(error: any) {
    if(error != null)
    if (error.message != this.dernierMessageErreur) {
      let log = new Log();
      log.utilisateurUsername = this.keycloakUtilisateurService.userName;
      log.type = "ERREUR";
      log.date = new Date();
      log.fonction = "CLIENT";
      if (error instanceof HttpErrorResponse) {
        //The response body may contain clues as to what went wrong,
        console.log(error);
      }
      else if (error instanceof TypeError) {
        console.error(error);
        log.message = error.message + error.stack;
        this.http.post('Log', log).subscribe(res => { });
      }
      else if (error instanceof Error) {
        console.error(error);
        log.message = error.message + error.stack;
        this.http.post('Log', log).subscribe(res => { });
      }
      else if (error instanceof ErrorEvent) {
        //A client-side or network error occurred. Handle it accordingly.
        console.error(error);
        log.message = error.message;
        this.http.post('Log', log).subscribe(res => { });
      }
      else {
        console.log(error);
      }
      this.dernierMessageErreur = error.message;
    }
  }
}
